import styled from 'styled-components';

export const Container = styled.div<{
  width?: number;
  open?: boolean;
  fullHeight?: boolean;
  direction: 'ltr' | 'rtl';
}>`
  position: fixed;
  top: 64px;
  right: ${({ direction }) => (direction === 'ltr' ? 0 : 'auto')};
  height: ${(props) =>
    props.open
      ? `${props.fullHeight ? '100vh' : 'calc(100vh - 64px)'}`
      : 'calc(100vh - 64px - 24px)'};
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  width: ${(props) => (props.open ? `${props.width}px` : '0')};
  transition: 0.5s;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  box-shadow: -10px 0px 30px -15px rgba(112, 122, 128, 0.2);
  border-top: 1px solid
    ${(props) => props.theme.atlas.semantic.color.ui.divider.default};
  z-index: 3;
  .marginBottom {
    margin-bottom: 100px;
  }
`;

export const Top = styled.span<{ width?: number; open?: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  height: 65px;
  width: ${(props) => (props.open ? `${props.width}px` : '0')};
  transition: 0.5s;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  z-index: 1;
`;
